import workspaceQuery from 'graphql/queries/diary/DiaryEventWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/diary/DiaryEventListQuery.graphql';
import instanceQuery from 'graphql/queries/diary/DiaryEventQuery.graphql';
import defaultQuery from 'graphql/queries/diary/DiaryEventDefault.graphql';
import mutationQuery from 'graphql/mutations/diary/DiaryEventMutation.graphql';
import aggregateQuery from 'graphql/queries/diary/DiaryEventAggregateQuery.graphql';
import fragment from 'graphql/fragments/diary/EventFragment.graphql';
import temporaryMutationQuery from 'graphql/mutations/diary/DiaryEventTempMutation.graphql';

import { workspace } from '../../../actions/diary/EventGlobalAmendAction';
import { EntityType } from '../../../@types/entityTypes';

export enum TaskPermission {
  Create = 'TASK_CREATE',
  Delete = 'TASK_DELETE',
  Update = 'TASK_UPDATE',
  View = 'TASK_VIEW',
}

const DiaryEvent: EntityType = {
  type: 'Event',
  title: 'Tasks',
  formTitle: 'Task',
  formUrl: '/Diary/Task/Details/',
  workspaceUrl: '/Diary/Task/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'duration',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'TASK',
  actions: [...workspace],
};

export default DiaryEvent;
